<template lang="pug">
  .summary-container(v-if="!disabled")
    .summary-box(v-if="summary")
      font-awesome-icon(icon="sparkle")
      span {{summary}}
    aiq-button(v-else @click="onSummarize")
      template(v-if="isSummarizing")
        font-awesome-icon(icon="spinner" spin)
      template(v-else)
        font-awesome-icon(icon="sparkles")
        span Summarize
</template>
<script>
import * as log from 'loglevel';
import SummaryMixin from '@/libs/mixins/Summary';

export default {
  name: 'summarize',
  mixins: [SummaryMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    summaryType: {
      type: String,
      default: 'metrics',
    },
    summaryName: {
      type: String,
      default: '',
    },
    summaryData: {
      type: Object,
      default: null,
    },
    summaryRange: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async onSummarize() {
      try {
        if (this.summaryType === 'metrics') {
          await this.onMetricsSummary(this.summaryName, this.summaryData, this.summaryRange);
        } else {
          throw new Error(`Unknown SummaryType(${this.summaryType}) to handle`);
        }
      } catch (error) {
        log.error('Error during summarization:', error);
        this.$emit('error', error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.summary-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 5px;

  & > * {
    background: #BCF5E4;
    box-shadow: 4px 1px 15px #d3d3d3;
    border: none;
    color: #41474d;
    margin-top: 5px;
    margin-bottom: 5px;

    .fa-sparkle, .fa-sparkles, .fa-plus, .fa-check {
      margin-right: 5px;
    }

    .fa-sparkle, .fa-sparkles, .fa-plus {
      color: #FFD43B;
    }

    .fa-check {
      color: green;
    }
  }

  & > button {
    border-radius: 50px;
  }

  .summary-box {
    text-align: center;
    border-radius: 5px;
    padding: 5px 50px;
    text-align: center;
  }
}


</style>
